export default "__VITE_ASSET__2bcf0396__"